import styled from "styled-components";
import { SideResponse } from "../../codegen-api";
import {
  COLORS,
  FIELD_COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS, FONT_SIZE } from "../../constants/design/fontSize";
import { BORDER_RADIUS, SPACING } from "../../constants/design/spacing";
import { sideColors } from "../../utils/sideColors";

export const InfoRow = styled.div<{
  warningOrError?: "warning" | "error";
  marginBottom?: number;
}>`
  &:not(:last-of-type) {
    margin-bottom: ${({ marginBottom }) =>
      marginBottom || SPACING.three}px !important;
  }

  > * {
    margin: auto 0 !important;
    color: ${({ warningOrError }) => {
      if (warningOrError === "warning") {
        return `${COLORS.system.one} !important`;
      }
      if (warningOrError === "error") {
        return `${COLORS.negative.one} !important`;
      }
      return undefined;
    }};
  }
`;

export const TradeInfoWrapper = styled.div`
  margin-top: ${SPACING.four}px;

  > * {
    display: flex;
    justify-content: space-between;
  }

  p {
    margin: 0;
  }
`;

export const Title = styled.p`
  ${FONT_CSS.label.two}
  color: ${TEXT_COLORS.three};
  display: flex;
  align-items: center;
  margin: auto 0;
`;

export const Value = styled.p`
  ${FONT_CSS.data.three}
  color: ${TEXT_COLORS.one};
  // font-family: BananaGroteskMono;
`;

export const PositionInfoWrapper = styled.div`
  margin: ${SPACING.three}px 0;
  padding: ${SPACING.two}px;
  background: ${LAYER_COLORS.two};
  border-radius: ${BORDER_RADIUS.two}px;

  > * {
    display: flex;
    justify-content: space-between;
  }

  p {
    margin: 0;
  }
`;

export const PositionChip = styled.span<{ $type: SideResponse }>`
  ${FONT_CSS.label.three}
  padding: 2px ${SPACING.one}px;
  border-radius: ${BORDER_RADIUS.two}px;
  background-color: ${(props) => sideColors(props.$type).six};
  color: ${(props) => sideColors(props.$type).one}!important;
  margin-left: ${SPACING.two}px;
  text-transform: capitalize;
`;

export const InputWrapper = styled.div`
  > * {
    &:not(:last-child) {
      margin-bottom: ${SPACING.two}px;
    }
  }

  > input {
    background: ${FIELD_COLORS.one};
  }
`;

export const Label = styled.span`
  text-transform: capitalize;
  display: inline-block;
  color: ${TEXT_COLORS.three};
  font-size: ${FONT_SIZE.one};
`;

export const WarningLabel = styled.span<{ $type?: "error" | "warning" }>`
  display: inline-block;
  color: ${({ $type }) =>
    $type === "warning" ? COLORS.system.one : COLORS.negative.one};
  font-size: ${FONT_SIZE.one};
`;
